var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinLid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 10,
    viewBox: "0 0 46 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1509 0.0820312C15.662 0.0820312 15.2449 0.435445 15.1645 0.917633L14.751 3.39843H1.37964C0.827354 3.39843 0.379639 3.84615 0.379639 4.39843V8.20224C0.379639 8.75452 0.827355 9.20224 1.37964 9.20224H44.981C45.5333 9.20224 45.981 8.75452 45.981 8.20224V4.39843C45.981 3.84615 45.5333 3.39843 44.981 3.39843H30.7806L30.3671 0.917632C30.2867 0.435444 29.8695 0.0820312 29.3807 0.0820312H16.1509Z",
    fill: "#5C4691"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinLid);
export default __webpack_public_path__ + "static/media/BinLid.2e8f7deb87d8743e5ee311b37c2361aa.svg";
export { ForwardRef as ReactComponent };